import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface SubscriptionStyles {
  container: Styles
  header: Styles
  subscriptionPlanContainer: Styles
  planTile: Styles
  planTileActive: Styles
}

const BORDER_WIDTH = 1
const ACTIVE_BORDER_WIDTH = 2

export const useStyles = createUseStyles<SubscriptionStyles>((theme) => {
  return {
    container: {
      maxHeight: '80vh',
      ...theme.breakpoint.up<Styles>('sm', {
        maxHeight: '90vh',
      }),
    },
    header: {
      marginTop: theme.calcUnit(theme.spacing.s2),
      paddingBottom: theme.calcUnit(theme.spacing.s3),
      borderBottom: `${theme.calcUnit(BORDER_WIDTH)} solid ${theme.colors.textFieldBorderColor}`,
    },
    subscriptionPlanContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    planTile: {
      marginTop: theme.calcUnit(theme.spacing.s4),
      color: theme.colors.webLinkText,
      textAlign: 'left',
      backgroundColor: theme.colors.backgroundColor,
      border: `${theme.calcUnit(BORDER_WIDTH)} solid`,
      borderColor: theme.colors.webTextFieldBorder,
      borderRadius: theme.calcUnit(theme.borderRadius.roundedMd),
      cursor: 'pointer',
    },
    planTileActive: {
      color: theme.colors.webInverseTextColor,
      backgroundColor: theme.colors.activeStateBackground,
      border: `${theme.calcUnit(ACTIVE_BORDER_WIDTH)} solid`,
      borderColor: theme.colors.activeTabBorderColor,
    },
  }
})
